import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  constructor(private snackBar: MatSnackBar) {}

  success(message: string, duration = 3000) {
    this.open(message, 'OK', duration, 'snack-success');
  }

  error(message: string, duration = 4000) {
    this.open(message, 'Close', duration, 'snack-error');
  }

  warning(message: string, duration = 3500) {
    this.open(message, 'Dismiss', duration, 'snack-warning');
  }

  info(message: string, duration = 3000) {
    this.open(message, 'OK', duration, 'snack-info');
  }

  close() {
    this.snackBar.dismiss();
  }

  private open(
    message: string,
    action: string,
    duration: number,
    panelClass: string
  ) {
    this.snackBar.dismiss();
    this.snackBar.open(message, action, {
      duration,
      panelClass,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}
